<template>
  <section id="hero" class="sticky top-0 bg-white z-10 border-b border-gray-100">
    <nav class="content-block">
      <div class="flex flex-wrap items-center justify-between mx-auto py-5">
        <!-- Logo -->
        <a href="#" class="flex items-center">
          <img src="/images/emojis/ice-cream.svg" class="h-7 mr-2" alt="Ice Cream Emoji" />
          <span class="self-center text-2xl font-semibold whitespace-nowrap text-gray-900"
            >Fitsnack</span
          >
        </a>

        <!-- Collapse Menu button && User Profile (Tablet / Mobile only) -->
        <div class="flex items-center gap-x-3 md:hidden">
          <button
            @click="toggleCollapse()"
            type="button"
            class="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg hover:bg-gray-100 focus:outline-hidden focus:ring-2 focus:ring-gray-200"
            aria-expanded="false"
          >
            <svg
              class="w-5 h-5"
              aria-hidden="true"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 17 14"
            >
              <path
                stroke="currentColor"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M1 1h15M1  7h15M1 13h15"
              />
            </svg>
          </button>
        </div>

        <!-- Menu -->
        <div class="hidden w-full md:block md:w-auto" ref="navbar">
          <ul
            class="font-medium flex flex-col gap-y-2 md:items-center p-4 md:p-0 mt-4 border border-gray-100 rounded-lg bg-gray-50 md:flex-row md:space-x-9 md:mt-0 md:border-0 md:bg-white"
          >
            <li v-for="item in navItems" :key="item.title">
              <a
                @click="onNavigate(item.sectionId)"
                class="menu-item transition-animation cursor-pointer"
              >
                {{ item.title }}
              </a>
            </li>

            <hr class="hidden md:block h-4 w-[1.5px] bg-gray-200" />

            <li>
              <template v-if="!UserService.user.value">
                <a
                  v-on:click="connectToStrava()"
                  class="menu-item transition-animation text-primary-500! md:hover:text-primary-600! cursor-pointer"
                >
                  Login
                  <svg
                    class="w-4 h-4"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 10"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M1 5h12m0 0L9 1m4 4L9 9"
                    />
                  </svg>
                </a>
              </template>
              <template v-else>
                <router-link
                  to="/profile"
                  class="menu-item transition-animation text-primary-500! md:hover:text-primary-600! cursor-pointer"
                >
                  Profile
                  <svg
                    class="w-4 h-4"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 14 10"
                  >
                    <path
                      stroke="currentColor"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2"
                      d="M1 5h12m0 0L9 1m4 4L9 9"
                    />
                  </svg>
                </router-link>
              </template>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  </section>
</template>

<script setup lang="ts">
import ScrollService from '@/services/scroll'
import StravaHelperService from '@/services/strava-helper'
import UserService from '@/services/user'
import { Collapse, type CollapseInterface } from 'flowbite'
import { onMounted, ref } from 'vue'

const navItems = [
  { title: 'How it works', sectionId: 'how-it-works' },
  { title: 'FAQs', sectionId: 'faqs' },
  { title: 'Join the club', sectionId: 'join-the-club' }
]

const navbar = ref<HTMLDivElement>()
const collapse = ref<CollapseInterface>()

onMounted(() => {
  initCollapse()
})

function initCollapse(): void {
  collapse.value = new Collapse(navbar.value)
}

function onNavigate(sectionId: string): void {
  collapse.value?.collapse()
  setTimeout(() => {
    ScrollService.scrollTo(sectionId)
  }, 200)
}

function toggleCollapse(): void {
  collapse.value?.toggle()
}
function connectToStrava() {
  window.location.assign(StravaHelperService.authPage('auto'))
}
</script>

<style scoped></style>
